{
	"type": "symbol",
	"minzoom": 8,
	"layout": {
		"icon-image": [
			"match",
			["get", "poitype"],
			"General Hospital",
			"rlgsp:health_hospital",
			"rlgsp:health_other"
		],
		"icon-overlap": "cooperative"
	},
	"paint": {}
}
